<template>
  <div class="Navi">
    <nav class="navbar navbar-expand-sm navbar-light">
      <!-- Links -->
      <ul class="nav navbar-nav ml-auto m-r">
        <!-- Dropdown -->
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="navbardrop" data-toggle="dropdown">
            Hola, {{name}}
          </a>
          <div class="dropdown-menu">
            <router-link to="/" v-slot="{href}">
              <a class="o-b" :href="href"> Salir </a>
            </router-link>
          </div>
        </li>
      </ul>
    </nav> 
  </div> 
</template>

<script>


export default {
  name: 'Navi',
  data () {
    return {
      name: ""
    }
  },
  beforeMount(){

    const data = this.$parse.User.current()
    const userAgain = data.id;
    this.name = data.name

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  
  .m-r{
    margin-right: 50px;
  }
  .dropdown-menu{
    width: 120px;
  }
  .navbar {
    padding: 2.5rem 1rem;
  }

  .navbar-expand-sm .navbar-nav .dropdown-menu {
    padding: 10px;
  
  }

  .dropdown-menu a{
    color: #000;
  }
  .dropdown-menu a:hover{
    color: #14fc78;
  }
    

</style>
